import { noop } from "lodash";
import React from "react";
import { isEventCardColumn } from "./EventCardColumn";
import { headingLevel } from "./EventCardColumnHeading";

type Props = {
  errorMessage?: string;
  headingLevel: headingLevel;
  loading?: boolean;
  onFlexibilityChange?: (eventId: string, isFlexible: boolean) => void;
  updating?: boolean;
};

const EventCardColumns = ({
  children,
  errorMessage,
  headingLevel,
  loading,
  onFlexibilityChange = noop,
  updating = false,
}: React.PropsWithChildren<Props>) => {
  const childrenWithProps = React.Children.map(children, (child) => {
    if (isEventCardColumn(child)) {
      return React.cloneElement(child as JSX.Element, {
        errorMessage,
        headingLevel,
        loading,
        onFlexibilityChange,
        updating,
        ...child.props,
      });
    }

    return child;
  });

  return (
    <div className="cw-grid cw-grid-cols-1 md:cw-grid-cols-3 cw-gap-2">{childrenWithProps}</div>
  );
};

export default EventCardColumns;
